import { TaskType } from "@common/types/task";

export const HAS_COMMAND_ISLAND_BY_TASK_TYPE = {
    [TaskType.INVITE_ACCOUNTANT]: true,
    [TaskType.RECEIPT_PHONE_NUMBER]: true,
    [TaskType.CONNECTION_BROKEN]: true,
    [TaskType.PLAID_NEW_ACCOUNTS_AVAILABLE]: true,
    [TaskType.PLAID_STATEMENTS_REFRESH]: true,
    [TaskType.MAP_CHART_OF_ACCOUNTS]: true,
    [TaskType.CONNECT_ACCOUNT]: true,
    [TaskType.MAP_MIGRATED_DATA]: true,
    [TaskType.INTEGRATION_COA_MAPPING]: true,
    [TaskType.FILE]: false,
    [TaskType.TRANSACTION]: false,
    [TaskType.TRANSACTIONS]: false,
    [TaskType.QUESTION]: false,
    [TaskType.PROFIT_LOSS_ACTIVATION]: false,
    [TaskType.PROFIT_LOSS]: false,
    [TaskType.BALANCE_SHEET]: false,
    [TaskType.DOCUMENT_RETRIEVAL]: false,
    [TaskType.GET_DOCUMENTS]: false,
    [TaskType.ACCRUAL_REVIEW]: false,
    [TaskType.RECONCILIATION]: false,
    [TaskType.FILE_MIGRATION_UPLOAD]: false,
    [TaskType.XERO_FILE_UPLOAD]: false,
    [TaskType.QBDT_FILE_UPLOAD]: false,
    [TaskType.TRANSACTION_REVIEW]: false,
    [TaskType.FORM_1099]: false,
    [TaskType.COUNTERPARTIES]: false,
    [TaskType.BILLS]: false,
    [TaskType.INVOICES]: false,
    [TaskType.FINANCIAL_DOCUMENTS]: false,
    [TaskType.SCHEDULE_RULE_SUGGESTED_REVIEW]: false,
    [TaskType.SCHEDULE_SUSPICIOUS_TRANSACTION_REVIEW]: false,
    [TaskType.REVENUE_RECOGNITION_REVIEW]: false,
    [TaskType.SCHEDULE_SOURCE_CHANGE_REVIEW]: false,
    [TaskType.MILESTONE_REVENUE_RECOGNITION_REVIEW]: false,
} as const satisfies Record<TaskType, boolean>;

export const hasTaskBodyCommandIsland = (taskType: TaskType): boolean =>
    HAS_COMMAND_ISLAND_BY_TASK_TYPE[taskType];
